// extracted by mini-css-extract-plugin
export default {"live_status":"index_live_status__34Cj9","status_icon_10":"index_status_icon_10__+elY0","status_icon_20":"index_status_icon_20__G4jnl","status_text":"index_status_text__ptEvB"};